import { TIFrameFields, TIFrameProps } from '../types/IFrame.types';
import { IFrameMock } from '../../../mocks/IFrame/IFrame.mock';

export class IFrameModel {
  private readonly fields: null | TIFrameFields;

  constructor(props: TIFrameProps) {
    this.fields = props.fields || null;
  }

  get url(): string {
    return (this.fields?.Link?.value?.url ?? IFrameMock?.fields?.Link?.value?.url) as string;
  }
}
